import {
  LayoutDashboard,
  ShoppingBag,
  Calendar,
  Book,
  Users,
  Receipt,
} from "lucide-react";
import { VideoFeature } from "./VideoFeatures";

export function Features() {
  const features = [
    {
      icon: LayoutDashboard,
      title: "Dashboard",
      description:
        "Visualize métricas importantes e tome decisões baseadas em dados",
    },
    {
      icon: ShoppingBag,
      title: "Pedidos",
      description: "Gerencie pedidos de forma eficiente e organizada",
    },
    {
      icon: Calendar,
      title: "Calendário",
      description: "Agende e organize suas entregas e compromissos",
    },
    {
      icon: Book,
      title: "Catálogo",
      description: "Mantenha seu catálogo digital sempre atualizado",
    },
    {
      icon: Users,
      title: "Clientes",
      description: "Cadastre e acompanhe o histórico dos seus clientes",
    },
    {
      icon: Receipt,
      title: "Despesas",
      description: "Controle financeiro completo do seu negócio",
    },
  ];

  return (
    <section id="features" className="py-20 px-4 container mx-auto">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12">
        TUDO QUE VOCÊ PRECISA EM{" "}
        <span className="text-gray-900 dark:text-gray-200 font-black">
          UM SÓ LUGAR
        </span>
      </h2>
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <VideoFeature
          videoUrl="/video-landing-page.mp4"
          posterUrl="/thumb-video-landing-page.webp"
        />
        <div className="grid grid-cols-2 gap-4">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 hover:bg-gradient-to-br hover:from-white hover:to-orange-50"
            >
              <feature.icon className="w-8 h-8 text-[#EE7B11] mb-3 transform transition-transform duration-300 hover:rotate-12" />
              <h3 className="text-gray-900 text-xl font-bold mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
